import { Tooltip, TooltipProps } from '@chakra-ui/react'
import { colors } from '@hb/shared'

export const ThemedTooltip = ({ children, ...props }: TooltipProps & { gray?: boolean }) => (
  <Tooltip
    color="white"
    bg={props.gray ? 'gray.500' : colors.green.hex}
    textShadow="1px 1px 3px #00000055"
    hasArrow
    {...props}>
    {children}
  </Tooltip>
)
